import React, { useState } from "react";
import "./BuildCourageExterior.css";

import KumatoGreenImg from "../../assets/images/buildCourage/mint.webp";
import BlackImg from "../../assets/images/buildCourage/black.webp";
import WhiteImg from "../../assets/images/buildCourage/white.webp";
import GreyImg from "../../assets/images/buildCourage/gray.webp";
import BlueImg from "../../assets/images/buildCourage/blue.webp";
import PinkImg from "../../assets/images/buildCourage/pink.webp";

const BuildCourageExterior = ({ onExteriorChange }) => {

  const exteriorOptions = [
    { id: "kumato-green", label: "Kumato Green", image: KumatoGreenImg, dotColor: "#9bbf7a" },
    { id: "white", label: "White", image: WhiteImg, dotColor: "#f5f5f5" },
    { id: "grey", label: "Grey", image: GreyImg, dotColor: "#b8b8b8" },
    { id: "black", label: "Black", image: BlackImg, dotColor: "#222" },
    { id: "blue", label: "Blue", image: BlueImg, dotColor: "#3b5f90" },
    { id: "pink", label: "Pink", image: PinkImg, dotColor: "#f8b4d0" }
  ];

  const [selectedExteriorId, setSelectedExteriorId] = useState(exteriorOptions[0].id);

  const selectedExterior = exteriorOptions.find((x) => x.id === selectedExteriorId);

  const handleSelectExterior = (id) => {
    setSelectedExteriorId(id);
    const selected = exteriorOptions.find((x) => x.id === id);
    if (onExteriorChange) onExteriorChange(selected);
  };

  return (
    <section className="build-ext-wrapper">
      <h2 className="build-ext-title">Choose exterior</h2>

      <div className="build-ext-dots-row">
        {exteriorOptions.map((opt) => (
          <button
            key={opt.id}
            type="button"
            className={`ext-dot-btn ${selectedExteriorId === opt.id ? "active" : ""}`}
            onClick={() => handleSelectExterior(opt.id)}
          >
            <span className="ext-dot-color" style={{ backgroundColor: opt.dotColor }} />
          </button>
        ))}
      </div>

      <div className="build-ext-image-wrapper">
        <img src={selectedExterior.image} alt={selectedExterior.label} className="build-ext-image" />
      </div>
    </section>
  );
};

export default BuildCourageExterior;
